import {connect} from 'react-redux';

import {batch} from '../../../../../libs/shared/core/src/store/helpers/reduxHelpers';
import {AppPanelId} from '../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {makeMapDispatchToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {computeMergeCardDetails} from '../../../../helpers/models/cardHelpers';
import {ThunkAction} from '../../../../store/appThunk';
import {hideBannerAction} from '../../../../store/panels/app/banners/bannersActions';
import {ContactDetailsErrorBannerState} from '../../../../store/panels/app/banners/bannersState';
import {
  popoutContactDetailsAction,
  previewMergeAction,
} from '../../../../store/panels/contacts/contactDetailsPanelActions';
import {ContactDetailsErrorBanner} from './contactDetailsErrorBanner';

/*
 * Props.
 */

interface ContactDetailsErrorBannerContainerProps {
  panelId: AppPanelId;
  state: ContactDetailsErrorBannerState;
}

/*
 * Redux.
 */

const mapDispatchToProps = makeMapDispatchToProps<ContactDetailsErrorBannerContainerProps>()((props) => {
  const {state} = props;
  return {
    onDismissClick: () => hideBannerAction(state.uid),
    onMergePreview: (): ThunkAction => (dispatch) => {
      const mainCard = state.params?.mainCard;
      const conflictingCard = state.params?.conflictingCard;
      const contactDetailsPanelId = state.params?.contactDetailsPanelId;

      if (mainCard && conflictingCard && contactDetailsPanelId) {
        const {mainCardId, mergeCardIds} = computeMergeCardDetails(mainCard, conflictingCard);
        batch(() => {
          dispatch(previewMergeAction(contactDetailsPanelId, mainCardId, [mainCardId, ...mergeCardIds]));
          dispatch(hideBannerAction(state.uid));
        });
      }
    },
    openContactDetailsPopUp: (): ThunkAction => (dispatch, getState) => {
      if (
        !state.params?.conflictingContactUid ||
        !state.params?.conflictingCard ||
        !state.params?.contactDetailsPanelId
      ) {
        return;
      }

      dispatch(
        popoutContactDetailsAction({
          parentPanelId: state.params.contactDetailsPanelId,
          selectedContactUid: state.params.conflictingContactUid,
          selectedCardId: state.params.conflictingCard.id,
          popupContactNamespace: state.params.conflictingCard.namespace,
        }),
      );
    },
  };
});

export const ContactDetailsErrorBannerContainer = connect(
  null,
  mapDispatchToProps,
)(ContactDetailsErrorBanner);
